<template lang="pug">
  small.form-text.text-danger
    img(src="../assets/img/red_error_msg.svg")
    | {{ message }}
    slot
</template>

<script>
export default {
  name: 'FormError',
  props: {
    message: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped>
img {
  width: 1rem;
  margin-right: 0.5rem;
}
</style>
